<template>
  <div class="reserceDesc">
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">预约服务</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div>
    <!-- 返回 结束 -->
    <!-- 服务信息 开始 -->
    <div class="reserceDesc_fuwumesg">
      <div class="reserceDesc_fuwutitle">
        <img class="reserceDesc_fuwuimg" src="/static/newprojecticon/title.png" />
        <div class="reserceDesc_fuwutitlename">服务信息</div>
      </div>
      <div class="reserceDesc_fuwuDetail">
        <!-- <div class="reserceDesc_productItemList" v-for="(item,index) in serviceItem.productItem " :key="index">
          <div class="reserceDesc_fuwuname">{{ item.name }}</div>
        </div> -->
        <div class="reserceDesc_productItemList">
          <div class="reserceDesc_fuwuname">{{serviceItem.product && serviceItem.product.name }}</div>
        </div>

        <div class="reserceDesc_fuwudesc">{{ serviceItem.name}}</div>
        <div class="reserceDesc_fuwuprice">
          <div class="reserceDesc_fuwupricename">服务价格</div>
          <div class="reserceDesc_fuwupricenum">{{serviceItem.price }}元</div>
        </div>
      </div>
    </div>
    <!-- 服务信息 结束 -->
    <!-- 预约信息 开始 -->
    <div class="reserceDesc_yuyuemesg">
      <div class="reserceDesc_fuwutitle">
        <img class="reserceDesc_fuwuimg" src="/static/newprojecticon/title.png" />
        <div class="reserceDesc_fuwutitlename">预约信息</div>
      </div>
      <div class="reserceDesc_fuwuDetail">
        <div class="reserceDesc_fuwuprice" @click="toLicenseList()">
          <div class="reserceDesc_fuwupricename">预约车牌</div>
          <div v-if="bookingItem.licenseItem.car_no">{{ bookingItem.licenseItem.car_no }}</div>
          <div v-if="!bookingItem.licenseItem.car_no" class="reserceDesc_fuwupricenum">请选择预约车牌
          </div>
        </div>
        <div class="reserceDesc_fuwuprice">
          <div class="reserceDesc_fuwupricename">预约日期</div>
          <div mode="date" @click="clickPicker" :value=" bookingItem.date" :start=" bookingItem.dateStart " :end=" bookingItem.dateEnd "
            id="date" :class=" bookingItem.date ? '' : 'reserceDesc_fuwupricenum' ">{{ bookingItem.date ? bookingItem.date  : '请选择预约日期' }}
          </div>
        </div>
      </div>
    </div>
    <!-- 预约信息 结束 -->
    <!-- 结算方式 开始 -->
    <div class="reserceDesc_yuyuemesg" v-if="package_id==''">
      <div class="reserceDesc_fuwutitle">
        <img class="reserceDesc_fuwuimg" src="/static/newprojecticon/title.png" />
        <div class="reserceDesc_fuwutitlename">结算方式</div>
      </div>
      <div class="reserceDesc_fuwuDetail">
        <!-- <div class="reserceDesc_fuwuprice" @click="buttonClicked ? '' : weixinPay() " id="amountPayChange">
          <div class="reserceDesc_fuwupricename">微信支付</div>
          <div class="reserceDesc_jiesuancheck">
            <div class="reserceDesc_jiesuanpricenum">{{serviceItem.price}}元</div>
            <img class="reserceDesc_check" :src="isWeixinPay? '/static/checkdeicon.png' : '/static/checkicon.png' " />
          </div>
        </div> -->
        <div class="reserceDesc_fuwuprice" @click="buttonClicked ? '' : amountPayChange() " id="amountPayChange">
          <div class="reserceDesc_fuwupricename">可用余额</div>
          <div class="reserceDesc_jiesuancheck">
            <div class="reserceDesc_jiesuanpricenum">{{amount}}</div>
            <img class="reserceDesc_check" :src="settlementItem.isAmountPay? '/static/checkdeicon.png' : '/static/checkicon.png' " />
            <!-- <input type="radio" name="pay_type" :disabled=" !settlementItem.canAmountPay " :checked=" settlementItem.isAmountPay " /> -->
          </div>
        </div>
        <div class="reserceDesc_fuwuprice" @click="(settlementItem.couponList && settlementItem.couponList.length) ? showPopup() : '' ">
          <div class="reserceDesc_fuwupricename">服务券</div>
          <div class="reserceDesc_jiesuancheck">
            <div class="reserceDesc_jiesuanpricenum">{{settlementItem.couponList ? settlementItem.couponList.length : 0}}
              张</div>
            <div class="reserceDesc_jiesuanpricenum" v-if="settlementItem.selectedID">已选</div>
            <div class="reserceDesc_jiesuanpricenum" v-else>未选</div>
            <img class="reserceDesc_check" :src="!!settlementItem.selectedID ? '/static/checkdeicon.png' : '/static/checkicon.png'" />
            <!-- <input type="radio" name="pay_type" disabled :checked="!!settlementItem.selectedID" /> -->
          </div>
        </div>
      </div>
    </div>
    <!-- 结算方式 结束 -->
    <!-- 支付 开始 -->
    <!--  <div class="page_button reserceDesc_button" @click="id !== booking_id ? (!!settlementItem.selectedID ? reserve(): yuyuepay()): reserve()"
      :id=" id !== booking_id ? 'pay': 'reserve' ">
      <div class="page_zhifu">{{ id !== booking_id ? "确定支付并预约保养" : "预约保养" }}</div>
    </div> -->
    <div class="page_button reserceDesc_button" @click="package_id=='' ? (!!settlementItem.selectedID ? reserve(): yuyuepay()): reserve()">
      <div class="page_zhifu">{{ package_id=='' ? "确定支付并预约保养" : "预约保养" }}</div>
    </div>
    <!-- 支付 结束 -->
    <!-- section-method:可使用券 start -->

    <van-popup v-model="show" position="bottom" :style="{ 'max-height': '70%' }">
      <div class="popup_top" @click="guanbi()">
        <img class="guanbi" src="/static/guanbi.png" />
        <div>可使用券</div>
      </div>
      <div class="couponCont maskCont">
        <div class="reserceDesc_section">
          <div class="scroll-div">
            <div v-for="(item,index) in settlementItem.couponList" :key="index" class="couponCell" hover-class="weui-cell_active"
              v-if="item.product.id == serviceItem.product_id && item.status == 0">
              <div class="cellLeft" @click="couponChange(index)">
                <div>{{ item.product.id == serviceItem.product_id ? '可用':'不可用' }}</div>
                <div class="cont">{{ item.product ? item.product.name : '' }}</div>
                <div>编号: {{ item.card_no }}</div>
                <div>到期: {{ item.overdue_at }}</div>
              </div>
              <input type="radio" @click="couponChange(index)" id="couponChange" name="coupon" :data-index="index"
                :disabled="item.product.id != serviceItem.product_id" :checked=" item.checked " />
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- section-method:可使用券 end -->
  </div>
</template>

<script>
  import weui from "weui.js";
  import httper from "../../api/http";
  import {
    Dialog
  } from 'vant';
  export default {
    data() {
      return {
        userInfo: {},
        mobile: "",
        id: "", // 上一页获取服务编号,默认为空
        store_id: "", //上一页获取的店铺id，默认空
        booking_id: "", // 上一页获取预约状态的服务编号,默认为空
        package_id: "", //用户从卡券列表进入时所带的卡券id
        itemId: "", //商品id
        serviceItem: {
          detail: "", // 服务详情
          wxDiscount: "", // 微支付优惠(暂弃
          wxPrice: "", // 服务价格减去微支付优惠后得到的微信应付金额(暂弃
          price: "" // 服务价格
        }, // 接口获取商品信息(待施工
        bookingItem: {
          licenseItem: {}, // 预约车牌,默认为空
          date: "", // 预约日期,默认为空
          dateStart: "", // 预约日期范围的开始,默认为今天common.getNowDate()
          dateEnd: "" // 预约日期范围的结束,默认为一周后common.getAddDate(common.getNowDate(), 0, 0, 7)
        }, // 接口获取预约信息
        amount: "0.00", // 可用余额
        settlementItem: {
          canAmountPay: false, // 前端计算可用余额是否大于服务价格,默认为false
          couponList: [], // 服务券列表,默认为空
          isAmountPay: false, // 用户是否使用余额结算,默认为false
          selectedID: "" // 用户选择服务券的编号,默认为空
        }, // 接口获取结算方式
        showTopTips: [{
            text: "请确定使用本服务的车辆!",
            checked: false
          },
          {
            text: "车牌号码填写不规则!",
            checked: false
          },
          {
            text: "请填写车辆品牌!",
            checked: false
          },
          {
            text: "请填写品牌型号!",
            checked: false
          },
          {
            text: "请选择预约日期!",
            checked: false
          },
          {
            text: "请勿重复添加车辆!",
            checked: false
          }
        ], // 错误提示列表
        productIndex: 0, // 商品套餐数组指针,默认为0
        carLicense: "", // 添加车辆时输入的车牌号码,默认为空
        carBrand: "", // 添加车辆时输入的品牌,默认为空
        carModel: "", // 添加车辆时输入的车型,默认为空
        maskStatus: "", // 遮盖层所展示的状态类型
        isMaskHidden: true, // 是否隐藏遮盖层,默认为true
        buttonClicked: false, // 防止用户重复点击,默认为false
        show: false, //是否显示服务券列表弹出框
        isWeixinPay: false //是否使用微信支付
      };
    },
    created() {
      //上页面店铺id
      if (this.$route.query.store_id) {
        this.store_id = this.$route.query.store_id
      }
      // if (this.$route.params.booking_id) {
      //   this.booking_id = this.$route.params.booking_id
      // }
      //上页面服务编号
      if (this.$route.query.id) {
        this.id = this.$route.query.id
      }
      //卡券列表进入时所带卡券id
      if (this.$route.query.package_id) {
        this.package_id = this.$route.query.package_id
      }
      //获取用户信息
      this.request("getUserInfo");
      //获取卡券列表
      this.request("getCouponList");
      //车牌列表进入时所带车牌信息
      if (this.$route.query.licenseItem) {
        this.bookingItem.licenseItem = this.$route.query.licenseItem
      }
    },
    mounted() {
      if (!this.id) return;
      let requestData = {
        id: this.id
      };
      this.request("getPackageDetail", requestData);
    },
    methods: {
      pageReturn(){
        this.$router.go(-1)
      },
      pageToIndex(){
        this.$router.push({
          path:"/"
        })
      },
      clickPicker() {
        const date = new Date();
        let datestart = new Date().getTime()
        let datestartyear = new Date(datestart).getFullYear();
        let datestartmonth1 = new Date(datestart).getMonth();
        let datestartdate = new Date(datestart).getDate();
        let datestartmonth = datestartmonth1 + 1
        let datestartdate1 = `${datestartyear}-${datestartmonth}-${datestartdate}`
        let datestarttime = Date.parse(datestartdate1.replace(/\-/g, ' '))
        let seven = 7 * 24 * 3600 * 1000;
        let sevenlater = datestarttime + seven;
        weui.datePicker({
          //如果默认时间不在开始和结束时间内，这个组件会卡死,这个是神奇的垃圾组件
          start: new Date(datestart).getFullYear(), // 起始时间
          end: new Date(datestart).getFullYear() + 1, // 结束时间
          //  start: this.bookingItem.dateStart, // 起始时间
          //     end: this.bookingItem.dateEnd, // 结束时间
          defaultValue: [date.getFullYear(), date.getMonth() + 1, date.getDate()], // 文档说默认当前值
          onChange: (result) => {

          },
          onConfirm: (result) => {
            let year = result[0].value;
            let month = result[1];
            let day = result[2].value;
            // this.bookingItem.date = `${year}-${month}-${day}`
            let confirmdate = `${year}-${month}-${day}`
            let datetime = Date.parse(confirmdate.replace(/\-/g, ' '))
            if (datetime < datestarttime || datetime > sevenlater) {
              this.$toast({
                message: '预约时间为一周内'
              })
              return
            } else {
              this.bookingItem.date = confirmdate
            }
          }
        });
      },
      /**
       * 防重点击
       * @param duration
       * @returns {Promise<any>}
       */
      buttonClickedFun(duration = 0) {
        this.buttonClicked = true;
        return new Promise((resolve, reject) => {
          if (duration && typeof duration === "number") {
            setTimeout(() => {
              this.buttonClicked = false;
            }, duration);
          }
          resolve(true);
        });
      },
      //关闭弹出层
      guanbi() {
        this.show = false
      },
      showPopup() {
        this.show = true
      },
      showTopTipsFun(showStatus = false, index = 0) {
        if (!showStatus) return;
        this.showTopTips[index].checked = true;
        setTimeout(() => {
          this.showTopTips[index].checked = false;
        }, 2000);
        return true;
      },
      // 展示/隐藏遮盖层
      scrolltolower() {
        let requestData = {
          product_id: this.product_id,
          lat: this.latitude,
          lng: this.longitude,
          page: this.storePage,
          page_size: this.page_size
        };
        if (this.cityStatus) requestData.city = this.city;
        this.request("getStoreList", requestData);
      },
      //选择微信结算
      weixinPay() {
        let settlementItem = this.settlementItem;
        this.settlementItem = settlementItem;
        if (!this.isWeixinPay) {
          this.settlementItem.selectedID = "";
          this.settlementItem.couponList.map(item => (item.checked = false));
          this.isWeixinPay = true
          this.settlementItem.isAmountPay = false
        } else this.isWeixinPay = false;
      },
      // 选择余额结算
      amountPayChange() {
        let settlementItem = this.settlementItem;
        if (!settlementItem.canAmountPay) return;
        this.settlementItem = settlementItem;
        if (!settlementItem.isAmountPay) {
          this.settlementItem.selectedID = "";
          this.settlementItem.couponList.map(item => (item.checked = false));
          this.settlementItem.isAmountPay = true;
          this.isWeixinPay = false
        } else this.settlementItem.isAmountPay = false;
      },
      // 选择服务券
      couponChange(sel_index) {
        let that = this
        let settlementItem = that.settlementItem;
        let couponList = settlementItem.couponList;
        couponList.map(function(item, i) {
          if (i == Number(sel_index)) {
            item.checked = true
            that.settlementItem.selectedID = item.id;
          } else {
            item.checked = false;
          }
        })
        that.settlementItem = settlementItem;
        that.settlementItem.isAmountPay = false;
        that.isWeixinPay = false
        that.guanbi();
      },
      yuyuepay() {
        let that = this
        let settlementItem = this.settlementItem;
        this.buttonClickedFun.call(this, 2000);
        if ((!this.mobile)) {
          Dialog.confirm({
              title: '提示',
              message: '请先绑定手机',
            })
            .then(() => {
              that.$router.push({
                path: "/changePhoneNum"
              })
            })
            .catch(() => {
              return false;
            });
        }
        // if (
        //   this.showTopTipsFun.call(
        //     this,
        //     Object.keys(this.bookingItem.licenseItem).length === 0
        //   )
        // )
        //   return;
        if ((!this.bookingItem.licenseItem.car_no)) {
          this.$toast({
            message: '请选择使用本服务的车辆'
          })
          return
        }
        if (!this.bookingItem.date) {
          this.$toast({
            message: '请选择预约日期'
          })
          return
        }
        let yueData = {
          // amount: this.serviceItem.productItem[this.productIndex].price,
          amount: this.serviceItem.price,
          type: "offline",
          // pay_type: "balance",
          product_type: 2,
          // product_item_id: this.serviceItem.productItem[this.productIndex].id,
          // recharge_number: this.bookingItem.licenseItem.card_no
          product_item_id: that.serviceItem.id,
          recharge_number: this.bookingItem.licenseItem.card_no
        }
        if (that.isWeixinPay) {
          Dialog.confirm({
              title: '提示',
              message: '是否用微信支付?',
            })
            .then(() => {
              yueData.pay_type = 'wechatpay'
              that.request('WxunifiedOrder', yueData)
            })
            .catch(() => {
              return false;
            });
        } else {
          if (parseFloat(this.amount) < parseFloat(this.serviceItem.price)) {
            Dialog.confirm({
                title: '提示',
                message: '积分不足，前往充值？',
              })
              .then(() => {
                that.$router.push({
                  path: "/account"
                })
              })
              .catch(() => {
                return false;
              });
          } else {
            Dialog.confirm({
                title: '提示',
                message: '是否用余额支付?',
              })
              .then(() => {
                yueData.pay_type = 'balance'
                that.request('YeunifiedOrder', yueData)
              })
              .catch(() => {
                return false;
              });
          }
        }

      },
      // reserve() {
      //   this.buttonClickedFun.call(this, 2000);
      //   if (
      //     this.showTopTipsFun.call(
      //       this,
      //       Object.keys(this.bookingItem.licenseItem).length === 0
      //     )
      //   )
      //     return;
      //   if (this.showTopTipsFun.call(this, !this.bookingItem.date, 4)) return;

      //   let requestData = {
      //     store_id: this.store_id,
      //     product_item_id: this.serviceItem.productItem[this.productIndex].id,
      //     subscribe_time: this.bookingItem.date,
      //     related_id: this.settlementItem.selectedID,
      //     user_car_id: this.bookingItem.licenseItem.id
      //   };
      //   this.request("packageBook", requestData);
      // },

      reserve() {
        this.buttonClickedFun.call(this, 2000);
        if ((!this.mobile)) {
          Dialog.confirm({
              title: '提示',
              message: '请先绑定手机',
            })
            .then(() => {
              that.$router.push({
                path: "/changePhoneNum"
              })
            })
            .catch(() => {
              return false;
            });
        }
        if ((!this.bookingItem.licenseItem.car_no)) {
          this.$toast({
            message: '请选择使用本服务的车辆'
          })
          return
        }
        if (!this.bookingItem.date) {
          this.$toast({
            message: '请选择预约日期'
          })
          return
        }
        // if (this.showTopTipsFun.call(this, !this.bookingItem.date, 4)) return;

        let requestData = {
          store_id: this.store_id,
          product_item_id: this.serviceItem.id,
          subscribe_time: this.bookingItem.date,
          related_id: this.settlementItem.selectedID,
          user_car_id: this.bookingItem.licenseItem.id
        };

        this.request("packageBook", requestData);
      },

      // picker组件的值改变时触发
      // change(e) {
      //   let value = e.detail.value
      //   let id = e.currentTarget.id
      //   let data = {}
      //   switch (id) {
      //     // 服务
      //     case 'product':
      //       if (this.productIndex === Number(value)) return
      //       this.serviceItem.productItem.map((item, index) => item.checked = index === Number(value))
      //       this.serviceItem = this.serviceItem
      //       this.productIndex = Number(value)
      //       break
      //       // 预约日期
      //     case 'date':
      //       this.bookingItem = this.bookingItem
      //       this.bookingItem.date = value
      //       break
      //   }
      // },

      // 跳转到车牌列表页
      toLicenseList() {
        this.$router.push({
          path: "/liceseList",
          query: {
            id: this.id,
            store_id: this.store_id,
            package_id: this.package_id
          }
        });
      },
      request(type = "", requestData = {}) {
        let that = this;
        switch (type) {
          //获取用户信息
          case 'getUserInfo':
            httper.get('wechat/user/info', requestData, res => {
              if (res.code == 0) {
                that.userInfo = res.data
                that.mobile = res.data.mobile
                let amount1 = res.data.account.amount.toFixed(2)
                that.amount = amount1;
                that.settlementItem = {
                  canAmountPay: amount1 >= that.serviceItem.price,
                  isAmountPay: true,
                  selectedID: "",
                  couponList: []
                };
              }
            }, true)
            break
            //获取套餐详情
          case "getPackageDetail":
            httper.get("/store/service-detail", requestData, res => {
                // that.serviceItem = res.data product/detail
                // res.data.productItem.map(
                //   (item, index) => (item.checked = index === that.packageIndex)
                // );
                that.serviceItem = res.data;
              },
              false
            );
            break;
            //卡券列表
          case "getCouponList":
            httper.post("coupon/package-list", requestData, res => {
              let list = [];
              if (res.data) {
                console.log("res.data", res.data)
                res.data.map(function(item, i) {
                  if (item.product_id == that.serviceItem.product_id && item.status == 0) {
                    list.push(item)
                  }
                })
              }
              console.log("list", list)
              that.settlementItem.couponList = list;

            });
            break;
            //预约
          case "packageBook":
            httper.post("coupon/book", requestData, res => {
                if (res.code == 0) {
                  this.$swal({
                    title: "预约成功"
                  }).then(confirm => {
                    if (confirm) {
                      this.$router.push({
                        path: "/detailBook",
                        query: {
                          id: res.data.related_id
                        }
                      });
                    } else {
                      return false;
                    }
                  });
                } else {
                  this.$toast({
                    message: res.message
                  });
                }
              },
              true
            );
            break;
            //确定支付并预约 余额支付
          case 'YeunifiedOrder':
            httper.post('/payment/unified-order', requestData, res => {
              if (res.code === 0) {
                this.$swal({
                  title: "支付成功"
                }).then(confirm => {
                  if (confirm.value) {
                    let requestData = {
                      store_id: this.store_id,
                      product_item_id: this.serviceItem.id,
                      subscribe_time: this.bookingItem.date,
                      // related_id: this.package_id,
                      user_car_id: this.bookingItem.licenseItem.id
                    };
                    this.request("packageBook", requestData);
                  } else {
                    return false;
                  }
                })
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            //微信下单
          case 'WxunifiedOrder':
            httper.post('/payment/unified-order', requestData, res => {
              console.log("微信支付信息", res)
              if (res.code === 0) {
                that.pay(res.data.payment_packet, res.data.order_no)
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            //微信取消下单
            case 'orderCancel':
              httper.post('/order/cancel', requestData, res => {
                console.log("取消", res)
                if (res.code === 0) {
                  // that.pay(res.data.payment_packet, res.data.order_no)
                } else {
                  this.$toast({
                    message: res.message || '系统异常',
                  })
                }
              }, true)
              break
        }
      },
      //发起支付
      pay(payment_packet, order_no) {
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no), false);
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no));
            document.attachEvent('onWeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no));
          }
        } else {
          this.jsApiCall(payment_packet, order_no);
        }
      },
      //调用微信支付
      jsApiCall(payment_packet, order_no) {

        let that = this
        if (!payment_packet) {
          this.$toast({
            message: '下单失败，请重试',
          })
          return
        }
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', payment_packet,
          function(res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠
              //支付成功去预约
              let requestData = {
                store_id: this.store_id,
                product_item_id: this.serviceItem.id,
                subscribe_time: this.bookingItem.date,
                user_car_id: this.bookingItem.licenseItem.id
              };
              this.request("packageBook", requestData);
            } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
              this.$toast({
                message: '取消支付'
              })
              this.request("orderCancel", {
                order_id: order_no
              })
              // that.$router.push({
              //   name: 'list'
              // })
            } else {
              this.$toast({
                message: '支付失败',
              })
            }
          }
        )
      },

    }
  };
</script>

<style scoped>
  .reserceDesc {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  /* 服务信息 开始 */
  .reserceDesc_fuwumesg {
    margin-top: 10px;
    width: 90%;
    height: 180px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 5px 2px rgba(187, 187, 187, 0.3);
    border-radius: 8px;
    padding: 20px;
    box-sizing: border-box;
  }

  .reserceDesc_yuyuemesg {
    margin-top: 10px;
    width: 90%;
    height: 176px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 5px 2px rgba(187, 187, 187, 0.3);
    border-radius: 8px;
    padding: 20px;
    box-sizing: border-box;
  }

  .reserceDesc_fuwutitle {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  .reserceDesc_fuwuimg {
    width: 4px;
    height: 23px;
    margin-right: 10px;
  }

  .reserceDesc_fuwutitlename {
    font-size: 15px;
    font-weight: bold;
    color: rgba(54, 54, 54, 1);
  }

  .reserceDesc_fuwuDetail {
    margin-top: 10px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
  }

  .reserceDesc_fuwuname {
    margin-bottom: 15px;
  }

  .reserceDesc_fuwudesc {
    margin-bottom: 15px;
  }

  .reserceDesc_fuwuprice {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }


  .reserceDesc_fuwupricename {}

  .reserceDesc_fuwupricenum {
    font-size: 12px;
    font-weight: 400;
    color: #FD8C00;
  }

  .reserceDesc_jiesuancheck {
    display: flex;
    justify-content: end;
    align-items: center;
  }

  .reserceDesc_jiesuanpricenum {
    font-size: 12px;
    font-weight: 400;
    color: #FD8C00;
    margin-right: 10px;
  }

  .reserceDesc_button {
    margin-top: 21px;
    margin-bottom: 20px;
  }

  /* 服务信息 结束 */
  /* pages/package/reserveDesc.wxss */


  .popup_top {
    display: flex;
    height: 30px;
    padding: 16px;
    border-bottom: 1px solid #d6d6d6;
    align-items: center;
    font-size: 18px;
  }

  .guanbi {
    width: 20px;
    height: 20px;
    margin-right: 130px;
  }

  .couponCell {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
  }

  .reserceDesc_section {
    padding: 10px;
  }

  .reserceDesc_check {
    width: 15px;
    height: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/xianxia/reserveDesc.vue